<template>
  <header>
    <h1>
      <router-link to="/">
        <img
          src="../../assets/images/logo-kakao-vx-2.png"
          srcset="
            ../../assets/images/logo-kakao-vx-2@2x.png 2x,
            ../../assets/images/logo-kakao-vx-2@3x.png 3x
          "
        />
      </router-link>
    </h1>

    <nav
      v-if="
        $store.getters.isOwner ||
        $store.getters.isAdmin ||
        $store.getters.isDeveloper
      "
    >
      <ul>
        <li>
          <router-link to="/campaign">캠페인 관리</router-link>
        </li>
        <li>
          <router-link to="/media">매체 관리</router-link>
        </li>
        <li>
          <router-link to="/partners">광고주 관리</router-link>
        </li>

        <li>
          <router-link to="/reportvx">리포트</router-link>
        </li>

        <li>
          <router-link to="/account">계정권한관리</router-link>
        </li>
      </ul>
    </nav>
    <nav v-else>
      <ul>
        <li>
          <router-link to="/report">리포트</router-link>
        </li>
      </ul>
    </nav>

    <div class="user-info" :class="{ active: userInfo }">
      <a
        href=""
        @click.prevent="userInfo = !userInfo"
        v-click-outside="onClickOutside"
      >
        <img
          :src="isUserSrc"
          :srcSet="isUserSrcSet"
          v-if="$store.state.user_type"
          alt=""
        />
        {{ $store.state.user_id }}
        <span>
          <v-icon>mdi-chevron-down</v-icon>
        </span>
      </a>

      <v-slide-y-transition>
        <div class="user-layer" v-if="userInfo">
          <div class="user-belong">
            <p class="thumb-name">
              <img
                :src="isUserSrc"
                :srcSet="isUserSrcSet"
                v-if="$store.state.user_type"
                alt=""
              />
              {{ $store.state.user_id }}
            </p>
          </div>
          <ul>
            <li>
              <a href="javascript:void(0);" @click.prevent="logoutPopup">
                로그아웃
              </a>
            </li>
          </ul>
        </div>
      </v-slide-y-transition>
    </div>

    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fff"
          class="button-type-1"
          @click.stop="showSystemAlert = false"
        >
          취소
        </v-btn>
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1 ml-2"
          @click.stop="logoutUser"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </header>
</template>

<script>
import { constantUserType } from '@/utils/constant';
import SystemAlert from '~@/modal/SystemAlert.vue';

export default {
  components: {
    SystemAlert,
  },
  data: () => ({
    userInfo: false,
    userDate: {},
    showSystemAlert: false,
    logResult: '',
  }),
  computed: {
    isUserLogin() {
      return this.$store.getters.isLogin;
    },
    isUserSrc() {
      const type =
        this.$store.state.user_type === constantUserType.User
          ? this.$store.state.advertiser_type
          : this.$store.state.user_type;
      return require(`@/assets/images/image-thumbnail-${type}.png`);
    },
    isUserSrcSet() {
      const type =
        this.$store.state.user_type === constantUserType.User
          ? this.$store.state.advertiser_type
          : this.$store.state.user_type;
      return `${require(`@/assets/images/image-thumbnail-${type}@2x.png`)} 2x, ${require(`@/assets/images/image-thumbnail-${type}@3x.png`)} 3x`;
    },
  },
  methods: {
    onClickOutside() {
      this.userInfo = false;
    },
    logoutPopup() {
      this.showSystemAlert = true;
      this.logResult = '로그아웃 하시겠습니까?';
    },
    async logoutUser() {
      await this.$store.dispatch('LOGOUT');
      this.$router.push('/login');
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
$transition: all 0.3s ease-in-out;

header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  min-width: 1280px;
  height: 72px;
  padding: 0 0 0 48px;
  background-color: #fecd06;
  z-index: 10;
}

nav {
  padding: 0 0 0 200px;
  ul {
    display: flex;
    align-items: center;
    li {
      padding: 0 12px;
      a {
        position: relative;
        display: block;
        min-width: 80px;
        height: 40px;
        line-height: 40px;
        color: #806703;
        font-size: 14px;
        font-weight: 700;
        text-align: center;
        transition: $transition;
        &:after {
          content: '';
          display: block;
          position: absolute;
          left: 50%;
          bottom: 0;
          width: 0;
          height: 3px;
          background-color: #fff;
          opacity: 0;
          transition: $transition;
        }
        &.router-link-active {
          color: #000;
          font-weight: 700;
          &:after {
            left: 0;
            width: 100%;
            opacity: 1;
          }
        }
      }
    }
  }
}

.user-info {
  position: absolute;
  top: 20px;
  right: 48px;
  > a {
    display: flex;
    align-items: center;
    color: #000;
    font-size: 14px;
    > img {
      width: 32px;
      height: 32px;
      margin-right: 8px;
      border-radius: 50%;
    }
    > span {
      margin-left: 8px;
      i {
        color: #000;
      }
    }
  }

  .user-layer {
    position: absolute;
    top: 60px;
    left: -16px;
    width: 196px;
    padding: 12px 0 8px;
    background-color: #fff;
    border: solid 1px #eee;
    border-radius: 4px;
    box-shadow: 0 8px 16px -8px rgba(0, 0, 0, 0.05);
    .user-belong {
      > p {
        margin-top: 4px;
        padding-left: 56px;
        color: #666;
        font-size: 10px;
        line-height: 1.2;
        letter-spacing: -0.3px;
      }
      .thumb-name {
        display: flex;
        align-items: center;
        color: #000;
        padding: 0 0 0 16px;
        font-size: 14px;
        > img {
          width: 32px;
          height: 32px;
          margin-right: 8px;
          border-radius: 50%;
        }
      }
    }
    > ul {
      margin-top: 16px;
      padding: 8px 0;
      border-top: 1px solid #eee;
      text-align: center;
      a {
        display: block;
        color: #666;
        font-size: 14px;
        line-height: 40px;
        &:hover {
          color: #000;
          background-color: #fefbf1;
        }
      }
    }
  }

  // active
  &.active {
    > a {
      > span {
        i {
          transform: rotate(-180deg);
        }
      }
    }
  }
}

// 1280이하
@media screen and (max-width: 1279px) {
  header {
    position: absolute;
  }
}
</style>
